import React from 'react';

const BASE = 'inline-flex items-center whitespace-nowrap leading-none';

const TMS_SHAPE = 'gap-1 rounded-[6px] px-2.5 py-1.5 text-[12px] font-medium';

// Not Tag's variants: Tag has one shape, and these pills differ per column in size, weight and radius.
const TONES = {
    leg: 'gap-1 rounded-[6px] border border-[#5049c0] bg-white px-2 py-[3px] text-[11px] font-semibold text-[#5049c0]',
    type: 'gap-1 rounded-[6px] bg-slate-100 px-2 py-[3px] text-[11px] font-semibold text-slate-700',
    tms: `${TMS_SHAPE} bg-slate-100 text-slate-700`,
    tmsBlue: `${TMS_SHAPE} bg-blue-100 text-blue-700`,
    tmsViolet: `${TMS_SHAPE} bg-violet-100 text-violet-700`,
    tmsTeal: `${TMS_SHAPE} bg-teal-100 text-teal-700`,
    tmsAmber: `${TMS_SHAPE} bg-amber-100 text-amber-800`,
    tmsRose: `${TMS_SHAPE} bg-rose-100 text-rose-700`,
    tmsCyan: `${TMS_SHAPE} bg-cyan-100 text-cyan-700`,
    owned: 'gap-1 rounded-[4px] bg-green-100 px-1.5 py-0.5 text-[10px] font-bold uppercase text-green-700',
    live: 'gap-2 rounded-full border border-green-100 bg-green-50 px-3.5 py-1.5 text-[12px] font-semibold text-green-700',
    ready: 'gap-2 rounded-full border border-blue-100 bg-blue-50 px-3.5 py-1.5 text-[12px] font-semibold text-blue-700',
    pending:
        'gap-2 rounded-full border border-amber-100 bg-amber-50 px-3.5 py-1.5 text-[12px] font-semibold text-amber-700',
    deactivated:
        'gap-2 rounded-full border border-red-200 bg-red-50 px-3.5 py-1.5 text-[12px] font-semibold text-red-700',
    complianceMet:
        'gap-1.5 rounded-[6px] border border-green-200 bg-green-50 px-2.5 py-1.5 text-[12px] font-semibold text-green-700',
    complianceMissing:
        'gap-1.5 rounded-[6px] border border-red-300 bg-red-50 px-2.5 py-1.5 text-[12px] font-semibold text-red-700',
};

const Pill = ({ tone, children, className = '' }) => (
    <span className={`${BASE} ${TONES[tone] || TONES.type} ${className}`}>{children}</span>
);

export const PillDot = () => <span className="size-1.5 shrink-0 rounded-full bg-current" aria-hidden="true" />;

export default Pill;
